
<div class="editor-model-prevnext">
  @if (rowIndex === 0) {
    <span class="prev-next-disabled" >< Previous</span>
  }
  @if (rowIndex !== 0) {
    <span (click)="openNextPrevItem(false)">< Previous</span>
  }
  |
  @if (!lastItem) {
    <span (click)="openNextPrevItem(true)">Next ></span>
  }
  @if (lastItem) {
    <span class="prev-next-disabled"  >Next ></span>
  }
</div>
